/* Isolated homepage component. No dependency on theme-wide variant/cart scripts. */
(() => {
  'use strict';
  if (customElements.get('vu-motion-home')) return;
  class VuMotionHome extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const data = this.querySelector('[data-motion-config]');
      if (!data) return;
      this.ready = true;
      const config = JSON.parse(data.textContent);
      const $ = selector => this.querySelector(selector);
      const $$ = selector => [...this.querySelectorAll(selector)];
      this.events = new AbortController();
      const on = (element, event, fn) => element?.addEventListener(event, fn, {signal:this.events.signal});
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const motion = () => !reduced.matches;
      const image = $('#vu-motion-config-image');
      const dialog = $('#vu-motion-zoom-dialog');
      let current, trigger;
      const select = (color, animate=true) => {
        const variant = config.variants.find(v => v.color === color);
        if (!variant) return;
        current = variant;
        $$('[data-color]').filter(el => el.tagName === 'BUTTON').forEach(button => {
          const candidate = config.variants.find(v => v.color === button.dataset.color);
          button.hidden = !candidate;
          button.setAttribute('aria-pressed', String(button.dataset.color === color));
        });
        const angle = color === 'black' ? '2deg' : '0deg';
        if (variant.image) {image.srcset = variant.srcset || ''; image.src = variant.image; image.hidden = false;} else {image.removeAttribute('srcset'); image.removeAttribute('src'); image.hidden = true;}
        image.dataset.color = color;
        image.style.setProperty('--vu-motion-product-angle', angle);
        image.alt = 'Blaze 2.0 — ' + variant.label;
        $('.vu-motion-color-word').textContent = variant.label.toUpperCase();
        $('#vu-motion-photo-color').textContent = variant.label.toUpperCase();
        $('#vu-motion-choice-name').textContent = variant.heading;
        $('#vu-motion-category').textContent = variant.cat;
        $('#vu-motion-vlt').textContent = variant.vlt + '\u00a0%';
        $('#vu-motion-choice-note').textContent = variant.note;
        $('#vu-motion-price').innerHTML = variant.price;
        $('#vu-motion-shop-link').href = variant.url;
        let stock = $('[data-stock]');
        if (!stock) {stock = document.createElement('p'); stock.dataset.stock=''; stock.setAttribute('role','status');$('.vu-motion-price-row').after(stock);}
        stock.textContent = variant.available ? config.available : config.sold_out;
        if (animate && motion()) {
          image.animate([{clipPath:'inset(0 100% 0 0)',transform:`scale(.87) rotate(${angle})`},{clipPath:'inset(0 0 0 0)',transform:`scale(.83) rotate(${angle})`}], {duration:620,easing:'cubic-bezier(.22,1,.36,1)'});
          $('.vu-motion-choice-summary').animate([{opacity:.25,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:350,easing:'ease-out'});
        }
      };
      const heroImg=$('.vu-motion-hero-photo>img');
      if(heroImg){
        let lastPulse=-Infinity;
        const pulse=()=>{if(!motion()||performance.now()-lastPulse<8000)return;lastPulse=performance.now();heroImg.animate([{transform:'translateX(-50%) scale(1)'},{transform:'translateX(-50%) scale(1.07)'},{transform:'translateX(-50%) scale(1)'}],{duration:2100,easing:'ease-in-out',delay:250});};
        this.heroObserver=new IntersectionObserver(entries=>{if(entries[0].intersectionRatio>=.6)pulse();},{threshold:[.6]});
        if(heroImg.complete)this.heroObserver.observe(heroImg);else on(heroImg,'load',()=>this.heroObserver.observe(heroImg));
      }
      $$('button[data-color]').forEach(button => on(button,'click',()=>select(button.dataset.color)));
      select((config.variants.find(v=>v.id===config.selected)||config.variants[0]).color,false);
      $$('[data-kit]').forEach(button=>on(button,'click',()=>{
        const kit = config.kits[button.dataset.kit];
        $$('[data-kit]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        $('.vu-motion-kit-label').textContent=kit.name;
        $('.vu-motion-kit-detail').textContent=kit.detail;
        const marker=$('.vu-motion-kit-marker');marker.style.left=kit.x+'%';marker.style.top=kit.y+'%';marker.textContent=kit.index;
        $('.vu-motion-kit-image-wrap img').style.transform=button.dataset.kit==='sun'?'scale(1)':'scale(1.035)';
      }));
      const range=$('#vu-motion-light-range'), compare=$('.vu-motion-scene-compare'),handle=$('.vu-motion-split-line');
      const split=value=>{range.value=value;compare.style.setProperty('--vu-motion-split',value+'%');};
      on(range,'input',()=>split(range.value));
      let dragging=false;
      handle.style.pointerEvents='auto';handle.style.cursor='ew-resize';handle.style.touchAction='pan-y';
      on(handle,'pointerdown',event=>{dragging=true;handle.setPointerCapture(event.pointerId);});
      on(handle,'pointermove',event=>{if(!dragging)return;const rect=compare.getBoundingClientRect();split(Math.min(90,Math.max(10,(event.clientX-rect.left)/rect.width*100)));});
      ['pointerup','pointercancel','lostpointercapture'].forEach(name=>on(handle,name,()=>dragging=false));
      if(compare&&range){
        let demoToken=0, demoDone=false;
        const stopDemo=()=>{demoToken++;};
        ['input','pointerdown'].forEach(name=>{on(range,name,stopDemo);on(handle,name,stopDemo);});
        const moveSplit=(from,to,duration,token)=>new Promise(resolve=>{const t0=performance.now();const step=now=>{if(token!==demoToken){resolve(false);return;}const p=Math.min(1,(now-t0)/duration);const eased=p<.5?2*p*p:1-Math.pow(-2*p+2,2)/2;split(Math.round((from+(to-from)*eased)*10)/10);if(p<1)requestAnimationFrame(step);else resolve(true);};requestAnimationFrame(step);});
        const wait=ms=>new Promise(r=>setTimeout(r,ms));
        const demo=async()=>{demoDone=true;const token=++demoToken;await wait(500);if(token!==demoToken)return;if(!await moveSplit(50,85,1500,token))return;await wait(400);if(!await moveSplit(85,15,2000,token))return;await wait(600);await moveSplit(15,50,1200,token);};
        this.compareObserver=new IntersectionObserver(entries=>{if(!demoDone&&entries[0].intersectionRatio>=.6&&motion())demo();},{threshold:[.6]});this.compareObserver.observe(compare);
      }
      const film=$('#vu-motion-lens-film'), start=$('#vu-motion-film-start'), stage=$('.vu-motion-film-stage');
      if(film&&start&&stage){
        /* the film stage renders only when the product metafield vunit.lens_video (or the override) has an mp4 */
        const sync=()=>{stage.classList.toggle('vu-motion-is-playing',!film.paused&&!film.ended);start.hidden=!film.paused||film.currentTime>0;};
        ['play','pause'].forEach(name=>on(film,name,sync));
        on(film,'ended',()=>{stage.classList.remove('vu-motion-is-playing');start.hidden=false;start.lastElementChild.textContent=config.replay;});
        const play=()=>film.play().catch(()=>{start.lastElementChild.textContent=config.video_error;film.controls=true;});
        let userPaused=false, autoPausing=false;
        on(film,'pause',()=>{if(!autoPausing&&!film.ended)userPaused=true;});
        on(start,'click',()=>{userPaused=false;if(film.ended)film.currentTime=0;play();});
        on($('#vu-motion-film-replay'),'click',()=>{userPaused=false;film.currentTime=0;play();});
        /* autoplay (muted, inline) once at least half of the film is on screen; off under prefers-reduced-motion */
        this.observer=new IntersectionObserver(entries=>{const e=entries[0];
          if(e.intersectionRatio<.05){if(!film.paused){autoPausing=true;film.pause();autoPausing=false;}return;}
          if(e.intersectionRatio>=.5&&motion()&&film.paused&&!film.ended&&!userPaused){film.muted=true;film.play().catch(()=>{});}
        },{threshold:[.05,.5]});this.observer.observe(film);
        on(document,'visibilitychange',()=>{if(document.hidden)film.pause();});
      }
      const zoom=(src,button,color='')=>{
        trigger=button;const detail=dialog.querySelector('img');detail.src=src;detail.style.transform=color==='black'?'rotate(2deg)':'none';
        dialog.showModal();
        if(motion())dialog.animate([{opacity:0,transform:'translateY(15px) scale(.98)'},{opacity:1,transform:'none'}],{duration:280,easing:'ease-out'});
      };
      $$('[data-zoom]').forEach(button=>on(button,'click',()=>zoom(button.dataset.zoom,button)));
      on($('[data-zoom-current]'),'click',event=>{if(current&&current.image)zoom(current.image,event.currentTarget,current.color);});
      on($('.vu-motion-dialog-close'),'click',()=>dialog.close());
      on(dialog,'click',event=>{if(event.target===dialog)dialog.close();});
      on(dialog,'close',()=>trigger?.focus());
    }
    disconnectedCallback(){this.events?.abort();this.observer?.disconnect();this.heroObserver?.disconnect();this.compareObserver?.disconnect();this.querySelector('video')?.pause();this.ready=false;}
  }
  customElements.define('vu-motion-home',VuMotionHome);
})();
